<template>
  <div id="endpoint-show">
    <error-page
      title="Ocorreu um erro!"
      v-if="errors.cantLoadDetails"
    >
      <template slot="description">
        Não foi possível carregar as informações da consulta.<br>
        Por favor tente novamente.
      </template>
      <template slot="actions">
        <button class="btn btn-primary -sm" @click="fetchEndpoint()">Recarregar</button>
        <router-link
          :to="{ name: 'Endpoint-Index' }"
          class="btn btn-primary -sm"
        >
          Voltar
        </router-link>
      </template>
    </error-page>

    <div class="page" v-else>
      <div
        class="card"
        :class="{ '-loading': loading }"
      >
        <div class="header">
          <div class="description">
            <h2 class="title">Editar Consulta</h2>
            <p class="subtitle"> Nesta tela você pode editar uma consulta.</p>
          </div>
        </div>

        <div class="body">
          <div class="alert -danger mb-4" v-if="errors.cantUpdate">
            <p class="title">Ocorreu um erro!</p>
            <p>Infelizmente não foi possível atualizar esta consulta, por favor tente novamente.</p>
          </div>

          <form-endpoint
            submit-text="Salvar"
            :form="endpoint"
            :errors="errors.form"
            @input="$store.commit('endpoint/setEndpoint', $event)"
            @submit="updateEndpoint()"
          />
        </div>

        <loader v-if="loading"></loader>
        <confirm-change-endpoint-name-modal ref="confirmChangeEndpointNameModal"/>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import { filter } from 'lodash';
import FormEndpoint from '@/endpoint/components/FormEndpoint.vue';
import Loader from '@/support/components/Loader.vue';
import ErrorPage from '@/support/components/page/ErrorPage.vue';
import ConfirmChangeEndpointNameModal from '@/endpoint/components/ConfirmChangeEndpointNameModal.vue';

export default {
  name: 'Edit',

  data() {
    return {
      loading: false,
      nameWasChanged: false,
      errors: {
        cantLoadDetails: false,
        cantUpdate: false,
        form: {
          name: [],
          label: [],
          path: [],
          value: [],
          tags: [],
          enable: [],
          fields: [],
        },
      },
    };
  },

  methods: {
    /**
     * Fetch endpoint details.
     *
     * @returns {Promise<void>}
     */
    async fetchEndpoint() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'endpoint/fetchEndpoint',
          { id: this.$route.params.id },
        );
      } catch (err) {
        this.errors.cantLoadDetails = true;
      } finally {
        this.loading = false;
        this.nameWasChanged = false;
      }
    },

    /**
     * Reset errors.
     */
    resetErrors() {
      this.errors.cantLoadDetails = false;
      this.errors.cantUpdate = false;
      this.errors.form.name = [];
      this.errors.form.label = [];
      this.errors.form.path = [];
      this.errors.form.value = [];
      this.errors.form.tags = [];
      this.errors.form.enable = [];
      this.errors.form.fields = [];
    },

    /**
     * Update the endpoint.
     *
     * @returns {Promise<void>}
     */
    async updateEndpoint() {
      try {
        if (this.nameWasChanged && !await this.$refs.confirmChangeEndpointNameModal.confirm()) {
          return;
        }

        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'endpoint/updateEndpoint',
          { id: this.$route.params.id, form: this.endpoint },
        );

        await this.$router.push({ name: 'Endpoint-Index' });
      } catch (err) {
        const { data, status } = err.response || {};

        if (status === 422) {
          this.errors.form.name = data.errors.name || [];
          this.errors.form.label = data.errors.label || [];
          this.errors.form.path = data.errors.path || [];
          this.errors.form.value = data.errors.value || [];
          this.errors.form.tags = data.errors.tags || [];
          this.errors.form.enable = data.errors.enable || [];
          this.errors.form.fields = data.errors.fields || [];

          filter(data.errors, (errors, key) => key.match(/tags.(.*).name/))
            .forEach((errors) => {
              this.errors.form.tags = this.errors.form.tags.concat(errors);
            });

          return;
        }

        this.errors.cantUpdate = true;
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    endpoint: {
      deep: true,
      handler(newEndpoint, oldEndpoint) {
        if (newEndpoint.name !== oldEndpoint.name) {
          this.nameWasChanged = true;
        }
      },
    },
  },

  computed: {
    ...mapState('endpoint', {
      endpoint: 'endpoint',
    }),
  },

  mounted() {
    this.fetchEndpoint();
  },

  components: {
    FormEndpoint,
    Loader,
    ErrorPage,
    ConfirmChangeEndpointNameModal,
  },
};
</script>

<style lang="scss" scoped>

</style>
